import { useTranslate } from '@tolgee/react';
import { getPartners, NavigationProps } from '@amf/shared/utils/navigation';
import { NewsListItemFragment } from '@amf/shared/types/graphql';
import Container from '@amf/shared/components/layout/Container';
import { GetServerSideProps } from 'next';
import { sdk } from '@amf/shared/lib/graphQlClient';
import { getLanguageLocale } from '@amf/shared/utils/languages';
import NewsList, { LIMIT } from '@amf/shared/components/news/NewsList';

export interface PageProps extends NavigationProps {
  news: NewsListItemFragment[];
}

export type Props = {
  news: NewsListItemFragment[];
  prefixes: { newsList: string };
};

function NewsListPage({ news, prefixes }: Props) {
  const { t } = useTranslate();
  return (
    <Container>
      <h1>{t('news.list.title')}</h1>
      <NewsList news={news} prefixes={prefixes} />
    </Container>
  );
}

export default NewsListPage;

export const getServerSideProps: GetServerSideProps<PageProps> = async ({ locale }) => {
  const { news, navigation } = await sdk.NewsListPage({
    union: process.env.NEXT_PUBLIC_UNION,
    locale: getLanguageLocale(locale!),
    limit: LIMIT,
    offset: 0,
  });

  return {
    props: {
      navigation,
      news,
      partners: await getPartners(),
    },
  };
};
